import { EMAIL, IN_APP, SMS, PUSH, WEB_PUSH, EMBEDDED, WHATS_APP } from 'constants/messageMediums';

export const METRICS_TABLE_TEST_IDS = {
  TABLE: 'metrics-table',
  HEADER_CELL: 'metrics-table-header-cell',
  MEDIUM_CELL: 'metrics-table-medium-cell',
  VALUE_CELL: 'metrics-table-value-cell',
};

export const CAMPAIGNS_DISPLAY_NAMES_TO_MEDIUM_MAP: Record<string, string> = {
  Email: EMAIL,
  'In-App': IN_APP,
  SMS: SMS,
  Push: PUSH,
  'Web Push': WEB_PUSH,
  Embedded: EMBEDDED,
  WhatsApp: WHATS_APP,
};
